const indicatorHtml = document.querySelector('#loader') ? document.querySelector('#loader').outerHTML : '';

export default indicatorHtml;